import { z } from "zod";

/**
 * Complete Slack app install - Request body.
 *
 * Slack redirects the installing browser to the backend callback, which forwards
 * `code` and `state` to the frontend unchanged; the frontend sends them here under
 * its own sign-in. `state` is the install handshake's id — a database-minted uuid.
 */
export const CompleteSlackAppInstallBodySchema = z.strictObject({
  code: z.string().min(1),
  state: z.uuid()
});

/** Complete Slack app install - the bot connection the install produced. */
export const CompleteSlackAppInstallResponseSchema = z.object({
  connectionId: z.string().min(1),
  deploymentId: z.string().min(1),
  handshakeId: z.string().min(1),
  botName: z.string(),
  teamName: z.string()
});

export type CompleteSlackAppInstallBody = z.infer<typeof CompleteSlackAppInstallBodySchema>;
